import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/es/integration/react';
import { ConnectedRouter } from 'react-router-redux';

import {
  displayUpdateNotification,
  setUpdateAvailable,
} from 'State/app/actions';

import { App } from './containers/';
import registerServiceWorker from './registerServiceWorker';
import ConfigureStore from './store';
import { RegisterConnectionStatusInterceptors } from './api/Interceptors';

import 'react-table/react-table.css';
import 'react-table-hoc-fixed-columns/lib/styles.css';
import 'Styles/common/reactTableFixedColumns.less';
import './styles/app.less';

const { store, history, persistor } = ConfigureStore();

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </PersistGate>
  </Provider>,
  document.getElementById('app')
);

RegisterConnectionStatusInterceptors(store);

const onUpdateAvailable = isAvailable => {
  store.dispatch(setUpdateAvailable(isAvailable));
  if (isAvailable) {
    store.dispatch(displayUpdateNotification());
  }
};

/** Caches the app shell */
registerServiceWorker(onUpdateAvailable);



// WEBPACK FOOTER //
// ./src/index.js